/* eslint-disable react/jsx-key */
import React from 'react'
import Donut from '../component/Donut'
import ContribBarChart from '../component/ContribBar'
import ContribEventsTable from '../component/EventsContribTable'
import { UnitContribDetail, CauseContribDetail } from '../component/ContribDetail'
import { format, dollarFormatter, pctFormatter, numFormatter } from '../utils'
import styled from 'styled-components'
import { fromNullable, Just, Nothing } from 'data.maybe'
import { connect } from 'react-redux'
import R from 'ramda'
import { getUnitMap } from 'analytics/selectors'
import { FullHeightSizer } from 'core/screen-util'
import { schemeCategory20c } from 'analytics'
const Header = styled.h1`
  text-align: center;
  font-size: 2.5em;
  color: #444;
`

const summaryColorScheme = schemeCategory20c
const detailColorScheme = schemeCategory20c

const unitTooltip = unitMap => ({ unitId, value }) =>
  `${unitMap[unitId] || unitId}: ${format(value, pctFormatter)}`

const eventTooltip = unitMap => ({ unitId, year, eventNum, value }) =>
  `${unitMap[unitId] || unitId} ${year} ${eventNum}: ${format(value, pctFormatter)}`

const causeCodeTooltip = ({ code, description, value }) =>
  `${code}-${description}: ${format(value, pctFormatter)}`

const unitKey = ({ unitId }) => unitId
const causeCodeKey = ({ code }) => code
const eventKey = ({ unitId, year, eventNum }) => `${unitId}-${year}-${eventNum}`
const identifyEvent = ({ unitId, year, eventNum }) => ({
  unitId,
  year,
  eventNum,
})
const contribPieVal = ({ value }) => value

const margin = { top: 30, right: 20, bottom: 30, left: 40 }

const BackDrop = styled.div`
  position: absolute;
  background-color: rgba(1, 1, 1, 0.3);
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  border-radius: 1.2%;
`
const Container = styled.div`
  position: relative;
`

const EVENT = 'EVENT'
const CAUSE = 'CAUSE'
const UNIT = 'UNIT'

const unitDonutLabel = ['Contributions', 'by', 'Units']
const causeDonutLabel = ['Contributions', 'by', 'Cause Codes']
const eventDonutLabel = ['Contributions', 'by', 'Events']

class ContribContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: undefined,
    }
    this.setEvent = this.setEvent.bind(this)
    this.setCause = this.setCause.bind(this)
    this.setUnit = this.setUnit.bind(this)
    this.clearSelected = this.clearSelected.bind(this)
    this.nextUnit = this.nextUnit.bind(this)
    this.previousUnit = this.previousUnit.bind(this)
    this.nextCause = this.nextCause.bind(this)
    this.previousCause = this.previousCause.bind(this)
  }

  clearSelected() {
    this.setState({
      selected: undefined,
    })
  }

  setEvent(selected) {
    this.setSelected(EVENT, selected)
  }

  setCause(selected) {
    this.setSelected(CAUSE, selected)
  }

  setUnit(selected) {
    this.setSelected(UNIT, selected)
  }

  previousUnit(unitId) {
    const {
      contrib: { unit },
    } = this.props
    const index = R.findIndex(d => unitId === d.unitId, unit)
    if (index >= 1) this.setUnit(unit[index - 1].unitId)
  }

  nextUnit(unitId) {
    const {
      contrib: { unit },
    } = this.props
    const index = R.findIndex(d => unitId === d.unitId, unit)
    if (index >= 0 && index !== unit.length - 1) this.setUnit(unit[index + 1].unitId)
  }

  previousCause(cCode) {
    const {
      contrib: { causeCode },
    } = this.props
    const index = R.findIndex(d => cCode === d.code, causeCode)
    if (index >= 1) this.setCause(causeCode[index - 1].code)
  }

  nextCause(cCode) {
    const {
      contrib: { causeCode },
    } = this.props
    const index = R.findIndex(d => cCode === d.code, causeCode)
    if (index >= 0 && index !== causeCode.length - 1) this.setCause(causeCode[index + 1].code)
  }

  setSelected(type, selected) {
    this.setState({
      selected: {
        type,
        selected,
      },
    })
  }

  render() {
    const { aggregate, contrib, unitMap, display, kpi } = this.props
    if (!contrib) return null
    const screenWidth = this.props.screenSize.width - 250
    const screenHeight = this.props.screenSize.height

    const { aggregated, monthly } = aggregate
    const { selected } = this.state

    const contentWidth = screenWidth - 20
    const contentHeight = screenHeight - 100
    const bottomHeight = contentHeight / 2
    const topHeight = contentHeight / 2
    const pieWidth = (screenWidth - 20) / 3

    const dollarKpi = ['LOST_REVENUE_PERCENT', 'LOST_MARGIN_PERCENT']
    const formatter = dollarKpi.includes(kpi) ? dollarFormatter : numFormatter

    const donutProps = {
      width: pieWidth,
      height: topHeight,
    }

    const unitProps = {
      ...donutProps,
      data: contrib.unit,
      pieVal: contribPieVal,
      sliceKey: unitKey,
      colorVal: unitKey,
      tooltip: unitTooltip(unitMap),
      label: unitDonutLabel,
      select: this.setUnit,
      identifySelection: unitKey,
      colorScheme: summaryColorScheme,
    }

    const causeCodeProps = {
      ...donutProps,
      data: contrib.causeCode,
      pieVal: contribPieVal,
      sliceKey: causeCodeKey,
      colorVal: causeCodeKey,
      tooltip: causeCodeTooltip,
      label: causeDonutLabel,
      select: this.setCause,
      identifySelection: causeCodeKey,
      colorScheme: summaryColorScheme,
    }

    const eventProps = {
      ...donutProps,
      data: contrib.event,
      pieVal: contribPieVal,
      sliceKey: eventKey,
      colorVal: eventKey,
      tooltip: eventTooltip(unitMap),
      label: eventDonutLabel,
      select: this.setEvent,
      identifySelection: identifyEvent,
      colorScheme: summaryColorScheme,
    }

    const barProps = {
      contentHeight: bottomHeight,
      contentWidth: screenWidth,
      data: monthly,
      margin,
      formatter,
    }
    const Modal = styled.div`
      background-color: white;
      margin-left: 10%;
      margin-right: 10%;
      margin-top: 30px;
      margin-bottom: 30px;
      border-radius: 5px;
      padding-top: 20px;
      padding-bottom: 2px;
    `
    const modalWidth = contentWidth * 0.8
    const modalHeight = contentHeight - 60

    const createModalContent = ({ type, selected }) => {
      switch (type) {
        case EVENT:
          return (
            <ContribEventsTable
              events={contrib.event}
              selected={selected}
              width={modalWidth}
              height={modalHeight}
            />
          )
        case UNIT:
          return (
            <UnitContribDetail
              unitId={selected}
              width={modalWidth}
              height={modalHeight}
              next={this.nextUnit}
              previous={this.previousUnit}
              colorScheme={detailColorScheme}
              hoverColor="#eee"
              aggregate={aggregate}
              contrib={contrib}
            />
          )
        case CAUSE:
          return (
            <CauseContribDetail
              causeCode={selected}
              width={modalWidth}
              height={modalHeight}
              next={this.nextCause}
              previous={this.previousCause}
              colorScheme={detailColorScheme}
              hoverColor="#eee"
              aggregate={aggregate}
              contrib={contrib}
            />
          )
        default:
          return null
      }
    }

    return (
      <div>
        <Header>
          {display} {format(aggregated, formatter)}
        </Header>
        <Container>
          <Donut {...causeCodeProps} />
          <Donut {...unitProps} />
          <Donut {...eventProps} />
          <ContribBarChart {...barProps} />
          {fromNullable(selected)
            .map(selected => (
              <BackDrop onClick={this.clearSelected}>
                <Modal onClick={e => e.stopPropagation()}>{createModalContent(selected)}</Modal>
              </BackDrop>
            ))
            .getOrElse(null)}
        </Container>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  unitMap: getUnitMap(state),
})

const NoDataWrapper = props =>
  fromNullable(props.aggregate)
    .chain(a => (R.isEmpty(a) ? Nothing() : Just(a)))
    .chain(() => fromNullable(props.contrib))
    .chain(a => (R.isEmpty(a) ? Nothing() : Just(a)))
    // eslint-disable-next-line react/jsx-key
    .map(_ => <ContribContent {...props} />)
    .getOrElse(null)

// const NoDataConnect = connect(mapStateToProps)(NoDataWrapper)

const FullHeightSizerComp = props => {
  const NoDataConnect = connect(mapStateToProps)(NoDataWrapper)

  return (
    <FullHeightSizer heightOffset={0}>
      {({ height, width }) => (
        <NoDataConnect {...props} screenSize={{ height: height, width: width - 20 }} />
      )}
    </FullHeightSizer>
  )
}

// export default NoDataConnect
// export default connect(mapStateToProps)(NoDataWrapper)
export default FullHeightSizerComp
